import React, { useState } from 'react';
import GetAQuote from '../modals/TechnologyWorkModal';

function DownloadApp({ heading, subheading, text, androidLink, iosLink, imageUrl, imageOnLeft, buttonName, listItem }) {
    const [openModal, setOpenModal] = useState(false);
    const [appName, setAppName] = useState('')
    const toggle = (heading) => {
        setOpenModal(!openModal);
        if (heading)
            setAppName(heading)
    }
    return (
        <section className="home-app-block download-app-pad r-bg-x my-4">
            <div className="container">
                <GetAQuote openModal={openModal} toggle={toggle} buttonName={'Book A Free Demo'} appName={appName} />
                <div className="row">
                    {/* {imageOnLeft ? (
                        <> */}
                    <div className={`col-lg-6 ${imageOnLeft ? 'order-lg-1' : 'order-lg-2'} order-1  vcenter`}>
                        <div className="sol-image m-mt30 d-flex justify-content-center"><img src={imageUrl} alt="our app" className="img-fluid download-app-image" /></div>
                    </div>
                    <div className={`col-lg-6 ${imageOnLeft ? 'order-lg-2' : 'order-lg-1'} order-2 vcenter`}>
                        <div className="sec-heading our-app-d">
                            <span className="sub-heading mb15">{subheading}</span>
                            <h2 className="mb15" style={{ paddingLeft: '20px' }}>{heading}</h2>
                            <p>{text}</p>
                            <ul className='ul-list mb30'>
                                {listItem.map((list, index) =>
                                    <li key={index}><b>{list.heading} : </b>{list.para}</li>
                                )}
                            </ul>
                            <div className='d-flex justify-content-center'>
                                <button className='ree-btn ree-btn-grdt1 mw-80 no-shadows' onClick={() => toggle(heading)}>Book A Free Demo</button>
                            </div>
                        </div>
                    </div>
                    {/* </>
                    ) : (
                        <>
                            <div className="col-lg-6 order-md-2 vcenter">
                                <div className="sec-heading our-app-d">
                                    <span className="sub-heading mb15">{subheading}</span>
                                    <h2 className="mb15" style={{ paddingLeft: '20px' }}>{heading}</h2>
                                    <p>{text}</p>
                                    <ul className='ul-list mb30'>
                                        {listItem.map((list, index) =>
                                            <li key={index}>{list}</li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-6 order-md-1 vcenter">
                                <div className="sol-image m-mt30 d-flex justify-content-center"><img src={imageUrl} alt="our app" className="img-fluid" style={{ width: '90%' }} /></div>
                            </div>
                        </>
                    )} */}
                </div>
            </div>
        </section>
    );
}

export default DownloadApp;
